import { useCurrentEstimatedPdfs } from '../composables/useCurrentEstimatedPdfs';
import { useCurrentClient } from '../composables/useCurrentClient';

import { useUserStore } from '../store/user';

import { addDaysToDate } from '../utils/date';

const PDF_JSON: { [key: string]: string | number } = {
  // strona pierwsza
  'dostawe-i-montaz-pompy-ciepla-powietrznej-do-co-i-cwu': '',
  'dostawe-i-montaz-instalacji-fotowoltaicznej': '',
  'dostawe-i-montaz-kotla-gazowego-1-lub-2-funkcyjnego': '',
  'dostawe-i-montaz-kotla-na-pelet-drzewny': '',
  'dostawe-i-montaz-elektrycznego-systemu-grzewczego': '',
  'dostawe-i-montaz-pompy-ciepla-powietrznej-do-cwu': '',
  'dostawe-i-montaz-klimatyzatorow': '',
  'dostawe-i-montaz-kotla-zgazowujacego-drewno': '',
  'ocieplenie-budynku-stropu-lub-poddasza': '',
  'dostawe-i-montaz-stolarki-okiennej-i-drzwiowej': '',
  'dostawe-i-montaz-okien-dachowych': '',
  'dostawe-i-montaz-instalacji-kolektorow-slonecznych': '',
  'modernizacje-instalacji-centralnego-ogrzewania': '',
  'audyt-energetyczny': '',
  'program-moj-prad-dotacja-dla-instalacji-fotowoltaicznych-do-205-tys-zl': '',
  'program-czyste-powietrze-dotacja-do-kompleksowej-termomodernizacji-do-136-tys-zl': '',
  'ulga-termomodernizacyjna-ulga-na-dzialania-termomodernizacyjne-do-18-tys-zl': '',

  // Fotowoltaika strona trzecia
  'fotowoltaika-moc-instalacji': '',
  'fotowoltaika-naslonecznienie': '',
  'fotowoltaika-prognozowana-produkcja-roczna': '',
  'fotowoltaika-pokrycie-zapotrzebowania-percent': '',
  'fotowoltaika-pokrycie-zapotrzebowania-percent-2': '',
  'fotowoltaika-moduly-nazwa-modulu': '',
  'fotowoltaika-moduly-technologia-modulu': '',
  'fotowoltaika-moduly-liczba-sztuk': '',
  'fotowoltaika-moduly-powierzchnia-instalacji': '',
  'fotowoltaika-moduly-gwarancja-produktu': '',
  'fotowoltaika-moduly-gwarancja-uzysku': '',
  'fotowoltaika-zasobnik-cwu': '',
  'fotowoltaika-system-ems': '',
  'fotowoltaika-system-ems-2': '',
  'fotowoltaika-wartosc-netto': '',
  'fotowoltaika-vat-wartosc-percent': '',
  'fotowoltaika-vat-kwota': '',
  'fotowoltaika-wartosc-brutto': '',
  'fotowoltaika-moj-prad-czyste-powietrze': '',
  'fotowoltaika-ulga-termomodernizacyjna': '',
  'fotowoltaika-efektywny-poziom-dotacji': '',
  'fotowoltaika-cena-po-dotacjach-i-ulgach': '',
  'fotowoltaika-inwerter-nazwa': '',
  'fotowoltaika-inwerter-moc': '',
  'fotowoltaika-inwerter-liczba-faz': '',
  'fotowoltaika-inwerter-gwarancja': '',
  'fotowoltaika-moduly-opis-technologii': '',

  // fotowoltaika-hybrydowa strona czwarta
  'fotowoltaika-hybrydowa-parametry-instalacji-moc-instalacji': '',
  'fotowoltaika-hybrydowa-parametry-instalacji-naslonecznienie': '',
  'fotowoltaika-hybrydowa-parametry-instalacji-prognozowana-produkcja-roczna': '',
  'fotowoltaika-hybrydowa-pokrycie-zapotrzebowania-percent': '',
  'fotowoltaika-hybrydowa-pokrycie-zapotrzebowania-2-kwh': '',
  'fotowoltaika-hybrydowa-moduly-nazwa-modulu': '',
  'fotowoltaika-hybrydowa-moduly-technologia-modulu': '',
  'fotowoltaika-hybrydowa-moduly-gwarancja-produktu': '',
  'fotowoltaika-hybrydowa-moduly-gwarancja-uzysku': '',
  'fotowoltaika-hybrydowa-moduly-liczba-modulow': '',
  'fotowoltaika-hybrydowa-moduly-przyblizona-powierzchnia-instalacji': '',
  'fotowoltaika-hybrydowa-inwerter-nazwa': '',
  'fotowoltaika-hybrydowa-inwerter-gwarancja': '',
  'fotowoltaika-hybrydowa-zasobnik-cwu': '',
  'fotowoltaika-hybrydowa-grzalka': '',
  'fotowoltaika-hybrydowa-system-ems': '',
  'fotowoltaika-hybrydowa-bateria-nazwa': '',
  'fotowoltaika-hybrydowa-bateria-gwarancja': '',
  'fotowoltaika-hybrydowa-wartosc-netto': '',
  'fotowoltaika-hybrydowa-vat-wartosc-percent': '',
  'fotowoltaika-hybrydowa-vat-kwota': '',
  'fotowoltaika-hybrydowa-wartosc-brutto': '',
  'fotowoltaika-hybrydowa-moj-prad-czyste-powietrze': '',
  'fotowoltaika-hybrydowa-ulga-termomodernizacyjna': '',
  'fotowoltaika-hybrydowa-efektywny-poziom-dotacji': '',
  'fotowoltaika-hybrydowa-cena-po-dotacjach-i-ulgach': '',
  'fotowoltaika-hybrydowa-bateria-pojemnosc': '',
  'fotowoltaika-hybrydowa-moduly-opis-technologii': '',
  'fotowoltaika-hybrydowa-inwertery-moc-ac': '',

  // Pompa ciepła CO/CWU strona piąta
  'pompa-ciepła-co-cwu-parametry-instalacji-moc-dobranej-instalacji': '',
  'pompa-ciepła-co-cwu-parametry-instalacji-moc-niezbedna-na-potrzeby-co-cwu-1': '',
  'pompa-ciepła-co-cwu-parametry-instalacji-moc-niezbedna-na-potrzeby-co-cwu-2': '',
  'pompa-ciepła-co-cwu-parametry-instalacji-laczne-zapotrzebowanie-na-moc-budynku': '',
  'pompa-ciepła-co-cwu-parametry-instalacji-zuzycie-energii-elektrycznej-przez-instalacje': '',
  'pompa-ciepła-co-cwu-parametry-instalacji-instalacja-fotowoltaiczna-do-pokrycia-pc': '',
  'pompa-ciepla-co-cwu-producent-i-model': '',
  'pompa-ciepla-co-cwu-technologia-pompy-ciepla': '',
  'pompa-ciepla-co-cwu-gwarancja': '',
  'pompa-ciepla-co-cwu-wspolczynnik-scopmin-temperatura-pracy-1': '',
  'pompa-ciepla-co-cwu-wspolczynnik-scopmin-temperatura-pracy-2': '',
  'pompa-ciepla-co-cwu-moc-pompy-1': '',
  'pompa-ciepla-co-cwu-moc-pompy-2': '',
  'pompa-ciepla-co-cwu-niezbedna-powierzchnia-na-zewnatrz-budynku': '',
  'pompa-ciepla-co-cwu-zasobniki-zasobnik-cwu-nazwa': '',
  'pompa-ciepla-co-cwu-zasobniki-bufor-nazwa': '',
  'pompa-ciepla-co-cwu-zasobniki-niezbedna-powierzchnia-wewnatrz-budynku': '',
  'pompa-ciepla-co-cwu-wartosc-netto': '',
  'pompa-ciepla-co-cwu-vat-wartosc-percent': '',
  'pompa-ciepla-co-cwu-vat-kwota': '',
  'pompa-ciepla-co-cwu-wartosc-brutto': '',
  'pompa-ciepla-co-cwu-swiadectwa-efektywnosci-energetycznej': '',
  'pompa-ciepla-co-cwu-dotacja-czyste-powietrze-moj-prad': '',
  'pompa-ciepla-co-cwu-ulga-termomodernizacyjna': '',
  'pompa-ciepla-co-cwu-efektywny-poziom-dotacji': '',
  'pompa-ciepla-co-cwu-cena-po-dotacjach-i-ulgach': '',
  'pompa-ciepła-co-cwu-parametry-instalacji-koszt-zuzytej-energii-elektrycznej': '',
  'pompa-ciepła-co-cwu-moduly-opis-technologii': '',

  // klimatyzacja strona szósta
  'klim-1-model': '',
  'klim-1-producent': '',
  'klim-1-wydajnosc-chlodnicza': '',
  'klim-1-wydajnosc-grzewcza': '',
  'klim-1-seer': '',
  'klim-1-scop': '',
  'klim-2-model': '',
  'klim-2-producent': '',
  'klim-2-wydajnosc-chlodnicza': '',
  'klim-2-wydajnosc-grzewcza': '',
  'klim-2-seer': '',
  'klim-2-scop': '',
  'klim-3-model': '',
  'klim-3-producent': '',
  'klim-3-wydajnosc-chlodnicza': '',
  'klim-3-wydajnosc-grzewcza': '',
  'klim-3-seer': '',
  'klim-3-scop': '',
  'klim-4-model': '',
  'klim-4-producent': '',
  'klim-4-wydajnosc-chlodnicza': '',
  'klim-4-wydajnosc-grzewcza': '',
  'klim-4-seer': '',
  'klim-4-scop': '',
  'klim-5-model': '',
  'klim-5-producent': '',
  'klim-5-wydajnosc-chlodnicza': '',
  'klim-5-wydajnosc-grzewcza': '',
  'klim-5-seer': '',
  'klim-5-scop': '',
  'klima-6-model': '',
  'klim-6-producent': '',
  'klim-6-wydajnosc-chlodnicza': '',
  'klim-6-wydajnosc-grzewcza': '',
  'klim-6-seer': '',
  'klim-6-scop': '',
  'klim-7-model': '',
  'klim-7-producent': '',
  'klim-7-wydajnosc-chlodnicza': '',
  'klim-7-wydajnosc-grzewcza': '',
  'klim-7-seer': '',
  'klim-7-scop': '',
  'klim-wartosc-netto': '',
  'klima-vat-wartosc-percent': '',
  'klima-vat-wartosc-kwotowa': '',
  'klima-wartosc-brutto': '',
  'klima-swiadectwa-efektywnosci-energetycznej': '',
  'klima-dotacja-czyste-powietrze': '',
  'klima-ulga-termomodernizacyjna': '',
  'klima-efektywny-poziom-dotacji': '',
  'klima-cena-po-dotacjach-i-ulgach': '',

  // kociol-peletowy strona siódma
  'kociol-peletowy-parametry-instalacji-moc-dobranej-instalacji': '',
  'kociol-peletowy-parametry-instalacji-moc-niezbedna-na-potrzeby-co-cwu-1': '',
  'kociol-peletowy-parametry-instalacji-moc-niezbedna-na-potrzeby-co-cwu-2': '',
  'kociol-peletowy-parametry-instalacji-laczne-zapotrzebowanie-na-moc-budynku': '',
  'kociol-peletowy-parametry-instalacji-zuzycie-energii-elektrycznej-przez-instalacje': '',
  'kociol-peletowy-parametry-instalacji-koszt-zuzytego-pelletu': '',
  'kociol-peletowy-parametry-instalacji-szacowana-ilosc-pelletu-spalanego-rocznie': '',
  'kociol-na-pellet-model': '',
  'kociol-na-pellet-technologia': '',
  'kociol-na-pellet-gwarancja': '',
  'kociol-na-pellet-moc-kotla-pojemnosc-zasobnika-na-pellet-1': '',
  'kociol-na-pellet-moc-kotla-pojemnosc-zasobnika-na-pellet-2': '',
  'kociol-na-pellet-certyfikat-ecodesing': '',
  'kociol-na-pellet-klasa-energetyczna': '',
  'kociol-na-pellet-powierzchnia-budynku': '',
  'kociol-peletowy-dodatkowe-elementy-cwu': '',
  'kociol-peletowy-dodatkowe-elementy-pompa-cyrkulacyjna': '',
  'kociol-peletowy-dodatkowe-elementy-nawiew': '',
  'kociol-peletowy-wartosc-netto': '',
  'kociol-peletowy-vat-wartosc-percent': '',
  'kociol-peletowy-vat-kwota': '',
  'kociol-peletowy-wartosc-brutto': '',
  'kociol-peletowy-swiadectwa-efektywnosci-energetycznej': '',
  'kociol-peletowy-dotacja-czyste-powietrze': '',
  'kociol-peletowy-ulga-termomodernizacyjna': '',
  'kociol-peletowy-efektywny-poziom-dotacji': '',
  'kociol-peletowy-cena-po-dotacjach-i-ulgach': '',
  'kociol-peletowy-parametry-instalacji-koszt-zuzytego-pelletu-2': '',
  'kociol-peletowy-dodatkowe-elementy-termostat-bezprzewodowy': '',
  'kociol-peletowy-dodatkowe-elementy-modul-internetowy': '',
  'kociol-peletowy-dodatkowe-elementy-pojemnosc': '',
  'kociol-peletowy-dodatkowe-elementy-gwarancja-zasobnika-cwu': '',
  'kociol-peletowy-moduly-opis-technologii': '',

  // kocioł-zgazowujący-drewno strona ósma
  'kociol-zgazowujacy-drewno-parametry-moc-dobranej-instalacji': '',
  'kociol-zgazowujacy-drewno-parametry-instalacji-moc-na-potrzeby-co-cwu-1': '',
  'kociol-zgazowujacy-drewno-parametry-instalacji-moc-na-potrzeby-co-cwu-2': '',
  'kociol-zgazowujacy-drewno-parametry-instalacji-zapotrzebowanie-na-moc-budynku': '',
  'kociol-zgazowujacy-drewno-parametry-instalacji-zuzycie-energii-przez-instalacje': '',
  'kociol-zgazowujacy-drewno-parametry-instalacji-koszt-zuzytego-drewna-1': '',
  'kociol-zgazowujacy-drewno-parametry-instalacji-koszt-zuzytego-drewna-2': '',
  'kociol-zgazowujacy-drewno-parametry-instalacji-ilosc-drewna-spalanego-rocznie': '',
  'kociol-na-zgazowanie-producent-i-model': '',
  'kociol-na-zgazowanie-technologia': '',
  'kociol-na-zgazowanie-gwarancja': '',
  'kociol-na-zgazowanie-moc-kotla': '',
  'kociol-na-zgazowanie-klasa-energetyczna': '',
  'kociol-na-zgazowanie-niezbedna-powierzchnia-wewnatrz-budynku': '',
  'kociol-na-zgazowanie-dodatkowe-elementy-cwuk': '',
  'kociol-na-zgazowanie-dodatkowe-elementy-pompa-cyrkulacyjna': '',
  'kociol-na-zgazowanie-dodatkowe-elementy-nawiew': '',
  'kociol-na-zgazowanie-dodatkowe-elementy-termostat-bezprzewodowy': '',
  'kociol-na-zgazowanie-dodatkowe-elementy-modul-internetowy': '',
  'kociol-na-zgazowanie-dodatkowe-elementy-pojemnosc': '',
  'kociol-na-zgazowanie-dodatkowe-elementy-gwarancja-zasobnika-cwu': '',
  'kociol-na-zgazowanie-wartosc-netto': '',
  'kociol-na-zgazowanie-vat-wartosc-percent': '',
  'kociol-na-zgazowanie-vat-kwota': '',
  'kociol-na-zgazowanie-wartosc-brutto': '',
  'kociol-na-zgazowanie-swiadectwa-efektywnosci-energetycznej': '',
  'kociol-na-zgazowanie-dotacja-czyste-powietrze': '',
  'kociol-na-zgazowanie-ulga-termomodernizacyjna': '',
  'kociol-na-zgazowanie-efektywny-poziom-dotacji': '',
  'kociol-na-zgazowanie-cena-po-dotacjach-i-ulgach': '',
  'kociol-na-zgazowanie-moduly-opis-technologii': '',

  // kociol-gazowy-1-funkcyjny strona dziewięć
  'kociol-gazowy-1-moc-dobranej-instalacji': '',
  'kociol-gazowy-1-niezbedna-moc-laczna-1': '',
  'kociol-gazowy-1-niezbedna-moc-laczna-2-1': '',
  'kociol-gazowy-1-niezbedna-moc-laczna-2-2': '',
  'kociol-gazowy-1-zuzycie-energii-elektrycznej-przez-instalacje': '',
  'kociol-gazowy-1-koszt-zuzytego-gazu-1': '',
  'kociol-gazowy-1-koszt-zuzytego-gazu-2': '',
  'kociol-gazowy-1-moduly-opis-technologii': '',
  'kociol-gazowy-1-producent-model': '',
  'kociol-gazowy-1-technologia': '',
  'kociol-gazowy-1-gwarancja-podstawowa': '',
  'kociol-gazowy-1-klasa-energetyczna': '',
  'kociol-gazowy-moc-kotla': '',
  'kociol-gazowy-1-niezbedna-powierzchnia': '',
  'kociol-gazowy-1-modul-sterowania-przez-internet': '',
  'kociol-gazowy-1-wniosek-warunkow-przylaczeniowych': '',
  'kociol-gazowy-1-projekt-rozprowadzenia-gazu-w-budynku': '',
  'kociol-gazowy-1-rozprowadzenie-gazu-w-budynku': '',
  'kociol-gazowy-1-projekt-przylacza-gazu': '',
  'kociol-gazowy-1-doprowadzenie-gazu-do-budynku': '',
  'kociol-gazowy-1-demontaz-kotla': '',
  'kociol-gazowy-1-nowy-reduktor-cisnienia': '',
  'kociol-gazowy-1-podgrzewacz-cwu': '',
  'kociol-gazowy-1-podpiecie-cyrkulacji': '',
  'kociol-gazowy-1-elementy-instalacji-1': '',
  'kociol-gazowy-1-elementy-instalacji-2': '',
  'kociol-gazowy-1-elementy-instalacji-3': '',
  'kociol-gazowy-1-wartosc-netto': '',
  'kociol-gazowy-1-vat-wartosc-percent': '',
  'kociol-gazowy-1-vat-kwota': '',
  'kociol-gazowy-1-wartosc-brutto': '',
  'kociol-gazowy-1-swiadectwa-efektywnosci-energetycznej': '',
  'kociol-gazowy-1-dotacja-czyste-powietrze': '',
  'kociol-gazowy-1-ulga-termomodernizacyjna': '',
  'kociol-gazowy-1-efektywny-poziom-dotacji': '',
  'kociol-gazowy-1-cena-po-dotacjach-i-ulgach': '',

  // kociol-gazowy-2-funkcyjny strona dziesięć
  'kociol-gazowy-2-moc-dobranej-instalacji': '',
  'kociol-gazowy-2-moc-niezbedna-co-cwu-1': '',
  'kociol-gazowy-2-moc-niezbedna-co-cwu-2': '',
  'kociol-gazowy-2-laczne-zapotrzebowanie-na-moc-budynku': '',
  'kociol-gazowy-2-zuzycie-energii-elektrycznej-przez-instalacje': '',
  'kociol-gazowy-2-koszt-zuzytego-gazu-1': '',
  'kociol-gazowy-2-koszt-zuzytego-gazu-2': '',
  'kociol-gazowy-2-opis-technologii': '',
  'kociol-gazowy-2-producent-model': '',
  'kociol-gazowy-2-technologia': '',
  'kociol-gazowy-2-gwarancja-podstawowa': '',
  'kociol-gazowy-2-klasa-energetyczna': '',
  'kociol-gazowy-2-moc-kotla': '',
  'kociol-gazowy-2-niezbedna-powierzchnia': '',
  'kociol-gazowy-2-modul-sterowania-przez-internet': '',
  'kociol-gazowy-2-wniosek-o-wydanie-warunkow-przylaczeniowych': '',
  'kociol-gazowy-2-projekt-rozprowadzenia-gazu-w-budynku': '',
  'kociol-gazowy-2-rozprowadzenie-gazu-w-budynku': '',
  'kociol-gazowy-2-projekt-przylacza-gazu': '',
  'kociol-gazowy-2-doprowadzenie-gazu-do-budynku': '',
  'kociol-gazowy-2-demontaz-kotla': '',
  'kociol-gazowy-2-nowy-reduktor-cisnienia': '',
  'kociol-gazowy-2-elementy-instalacji-1': '',
  'kociol-gazowy-2-elementy-instalacji-2': '',
  'kociol-gazowy-2-elementy-instalacji-3': '',
  'kociol-gazowy-2-wartosc-netto': '',
  'kociol-gazowy-2-vat-wartosc-percent': '',
  'kociol-gazowy-2-vat-kwota': '',
  'kociol-gazowy-2-wartosc-brutto': '',
  'kociol-gazowy-2-swiadectwa-efektywnosci-energetycznej': '',
  'kociol-gazowy-2-dotacja-czyste-powietrze': '',
  'kociol-gazowy-2-ulga-termomodernizacyjna': '',
  'kociol-gazowy-2-efektywny-poziom-dotacji': '',
  'kociol-gazowy-2-cena-po-dotacjach-i-ulgach': '',

  // kociol-elektryczny strona jedenaście
  'kociol-elektryczny-moc-dobranej-instalacji': '',
  'kociol-elektryczny-moc-niezbedna-co-cwu-1': '',
  'kociol-elektryczny-moc-niezbedna-co-cwu-2': '',
  'kociol-elektryczny-laczne-zapotrzebowanie-na-moc-budynku': '',
  'kociol-elektryczny-zuzycie-energii-elektrycznej-przez-instalacje': '',
  'kociol-elektryczny-koszt-zuzytej-energii-elektrycznej-1': '',
  'kociol-elektryczny-koszt-zuzytej-energii-elektrycznej-2': '',
  'kociol-elektryczny-opis-technologii': '',
  'kociol-elektryczny-producent-model': '',
  'kociol-elektryczny-technologia': '',
  'kociol-elektryczny-gwarancja': '',
  'kociol-elektryczny-klasa-energetyczna': '',
  'kociol-elektryczny-moc-kotla': '',
  'kociol-elektryczny-niezbedna-powierzchnia': '',
  'kociol-elektryczny-podgrzewacz-cwu': '',
  'kociol-elektryczny-podpiecie-cyrkulacji': '',
  'kociol-elektryczny-termostat': '',
  'kociol-elektryczny-demontaz-kotla': '',
  'kociol-elektryczny-reduktor-cisnienia': '',
  'kociol-elektryczny-zabezpieczenie-roznicowopradowe': '',
  'kociol-elektryczny-elementy-instalacji-obieg': '',
  'kociol-elektryczny-wartosc-netto': '',
  'kociol-elektryczny-vat-wartosc-percent': '',
  'kociol-elektryczny-vat-kwota': '',
  'kociol-elektryczny-wartosc-brutto': '',
  'kociol-elektryczny-swiadectwa-efektywnosci-energetycznej': '',
  'kociol-elektryczny-dotacja-czyste-powietrze': '',
  'kociol-elektryczny-ulga-termomodernizacyjna': '',
  'kociol-elektryczny-efektywny-poziom-dotacji': '',
  'kociol-elektryczny-cena-po-dotacjach-i-ulgach': '',

  // Elektryczne-folie-maty-promienniki strona dwanaście
  'elektryczne-folie-maty-promienniki-m2-folii-grzewczych': '',
  'elektryczne-folie-maty-promienniki-m2-mat-grzewczych': '',
  'elektryczne-folie-maty-promienniki-szt-promiennikow': '',
  'elektryczne-folie-maty-promienniki-folie-grzewcze': '',
  'elektryczne-folie-maty-promienniki-maty-grzewcze': '',
  'elektryczne-folie-maty-promienniki-promienniki-grzewcze': '',
  'elektryczne-folie-maty-promienniki-dodatkowe-nozki': '',
  'elektryczne-folie-maty-promienniki-termostaty': '',
  'elektryczne-folie-maty-promienniki-termostaty-wifi': '',
  'elektryczne-folie-maty-promienniki-modernizacja-rozdzielni': '',
  'elektryczne-folie-maty-promienniki-nowe-obwody-elektryczne': '',
  'elektryczne-folie-maty-promienniki-wartosc-netto': '',
  'elektryczne-folie-maty-promienniki-vat-wartosc-percent': '',
  'elektryczne-folie-maty-promienniki-vat-kwota': '',
  'elektryczne-folie-maty-promienniki-wartosc-brutto': '',
  'elektryczne-folie-maty-promienniki-swiadectwa-efektywnosci-energetycznej': '',
  'elektryczne-folie-maty-promienniki-dotacja-czyste-powietrze': '',
  'elektryczne-folie-maty-promienniki-ulga-termomodernizacyjna': '',
  'elektryczne-folie-maty-promienniki-efektywny-poziom-dotacji': '',
  'elektryczne-folie-maty-promienniki-cena-po-dotacjach-i-ulgach': '',

  // pompa-ciepla-cwu strona trzynaście
  'pompa-ciepla-cwu-moc-instalacji': '',
  'pompa-ciepla-cwu-moc-niezbedna-co-cwu': '',
  'pompa-ciepla-cwu-czas-nagrzania-zbiornika-1': '',
  'pompa-ciepla-cwu-czas-nagrzania-zbiornika-2': '',
  'pompa-ciepla-cwu-zuzycie-energii-przez-instalacje': '',
  'pompa-ciepla-cwu-koszt-zuzytej-energii': '',
  'pompa-ciepla-cwu-instalacja-fotowoltaiczna-do-pokrycia-pc': '',
  'pompa-ciepla-cwu-opis-technologii': '',
  'pompa-ciepla-cwu-producent-model': '',
  'pompa-ciepla-cwu-technologia': '',
  'pompa-ciepla-cwu-gwarancja': '',
  'pompa-ciepla-cwu-scop': '',
  'pompa-ciepla-cwu-min-temp-pracy': '',
  'pompa-ciepla-cwu-moc-pompy-a15w45': '',
  'pompa-ciepla-cwu-moc-grzalki': '',
  'pompa-ciepla-cwu-powierzchnia': '',
  'pompa-ciepla-cwu-pojemnosc-zasobnika': '',
  'pompa-ciepla-cwu-wartosc-netto': '',
  'pompa-ciepla-cwu-vat-wartosc-percent': '',
  'pompa-ciepla-cwu-vat-kwota': '',
  'pompa-ciepla-cwu-wartosc-brutto': '',
  'pompa-ciepla-cwu-swiadectwa-efektywnosci-energetycznej': '',
  'pompa-ciepla-cwu-dotacja-czyste-powietrze-moj-prad': '',
  'pompa-ciepla-cwu-ulga-termomodernizacyjna': '',
  'pompa-ciepla-cwu-efektywny-poziom-dotacji': '',
  'pompa-ciepla-cwu-cena-po-dotacjach-i-ulgach': '',

  // kolektory-sloneczne strona czternaście
  'kolektory-sloneczne-ilosc-kolektorow': '',
  'kolektory-sloneczne-powierzchnia-kolektorow': '',
  'kolektory-sloneczne-moc-instalacji': '',
  'kolektory-sloneczne-optymalna-liczba-mieszkancow': '',
  'kolektory-sloneczne-szacowana-roczna-produkcja-energii': '',
  'kolektory-sloneczne-opis-technologii': '',
  'kolektory-sloneczne-producent-i-model': '',
  'kolektory-sloneczne-absorber': '',
  'kolektory-sloneczne-uklad-hydrauliczny': '',
  'kolektory-sloneczne-szyba': '',
  'kolektory-sloneczne-gwarancja': '',
  'kolektory-sloneczne-podgrzewacz-cwu': '',
  'kolektory-sloneczne-podpietcie-gornej-wezownicy': '',
  'kolektory-sloneczne-montaz-grzalki-elektrycznej': '',
  'kolektory-sloneczne-reduktor-cisnienia': '',
  'kolektory-sloneczne-przekop-nieutwardzony': '',
  'kolektory-sloneczne-przekop-utwardzony': '',
  'kolektory-sloneczne-wartosc-netto': '',
  'kolektory-sloneczne-vat-wartosc-percent': '',
  'kolektory-sloneczne-vat-kwota': '',
  'kolektory-sloneczne-wartosc-brutto': '',
  'kolektory-sloneczne-swiadectwa-efektywnosci-energetycznej': '',
  'kolektory-sloneczne-dotacja-czyste-powietrze-moj-prad': '',
  'kolektory-sloneczne-ulga-termomodernizacyjna': '',
  'kolektory-sloneczne-efektywny-poziom-dotacji': '',
  'kolektory-sloneczne-cena-po-dotacjach-i-ulgach': '',

  // modernizacja-centralnego-ogrzewania strone pietnaście
  'modernizacja-centralnego-ogrzewania-ilosc-grzejnikow': '',
  'modernizacja-centralnego-ogrzewania-ilosc-grzejnikow-lazienkowych': '',
  'modernizacja-centralnego-ogrzewania-powierzchnia-ogrzewania': '',
  'modernizacja-centralnego-ogrzewania-liczba-rozdzielaczy': '',
  'modernizacja-centralnego-ogrzewania-dlugosc-tras': '',
  'modernizacja-centralnego-ogrzewania-liczba-zaworow-z-glowica': '',
  'modernizacja-centralnego-ogrzewania-liczba-zaworow-z-glowica-i-powrotnym': '',
  'modernizacja-centralnego-ogrzewania-wartosc-netto': '',
  'modernizacja-centralnego-ogrzewania-vat-wartosc-percent': '',
  'modernizacja-centralnego-ogrzewania-vat-wartosc-kwotowa': '',
  'modernizacja-centralnego-ogrzewania-wartosc-brutto': '',
  'modernizacja-centralnego-ogrzewania-swiadectwa-efektywnosci-energetycznej': '',
  'modernizacja-centralnego-ogrzewania-dotacja-czyste-powietrze': '',
  'modernizacja-centralnego-ogrzewania-ulga-termomodernizacyjna': '',
  'modernizacja-centralnego-ogrzewania-efektywny-poziom-dotacji': '',
  'modernizacja-centralnego-ogrzewania-cena-po-dotacjach-i-ulgach': '',

  // ocieplenie-budynku strona szesnaście
  'ocieplenie-budynku-powierzchnia-fasada-1': '',
  'ocieplenie-budynku-grubosc-fasada-1': '',
  'ocieplenie-budynku-wspolczynnik-fasada-1': '',
  'ocieplenie-budynku-tynk-fasada-1': '',
  'ocieplenie-budynku-marmolit-styrodur-fasada-1': '',
  'ocieplenie-budynku-marmolit-fasada-1': '',
  'ocieplenie-budynku-styrodur-fasada-1': '',
  'ocieplenie-budynku-cena-fasada-1': '',
  'ocieplenie-budynku-powierzchnia-fasada-2': '',
  'ocieplenie-budynku-grubosc-fasada-2': '',
  'ocieplenie-budynku-wspolczynnik-fasada-2': '',
  'ocieplenie-budynku-tynk-fasada-2': '',
  'ocieplenie-budynku-marmolit-styrodur-fasada-2': '',
  'ocieplenie-budynku-marmolit-fasada-2': '',
  'ocieplenie-budynku-styrodur-fasada-2': '',
  'ocieplenie-budynku-cena-fasada-2': '',
  'ocieplenie-budynku-powierzchnia-fasada-3': '',
  'ocieplenie-budynku-grubosc-fasada-3': '',
  'ocieplenie-budynku-wspolczynnik-fasada-3': '',
  'ocieplenie-budynku-tynk-fasada-3': '',
  'ocieplenie-budynku-marmolit-styrodur-fasada-3': '',
  'ocieplenie-budynku-marmolit-fasada-3': '',
  'ocieplenie-budynku-styrodur-fasada-3': '',
  'ocieplenie-budynku-cena-fasada-3': '',
  'ocieplenie-budynku-powierzchnia-fasada-4': '',
  'ocieplenie-budynku-grubosc-fasada-4': '',
  'ocieplenie-budynku-wspolczynnik-fasada-4': '',
  'ocieplenie-budynku-tynk-fasada-4': '',
  'ocieplenie-budynku-marmolit-styrodur-fasada-4': '',
  'ocieplenie-budynku-marmolit-fasada-4': '',
  'ocieplenie-budynku-styrodur-fasada-4': '',
  'ocieplenie-budynku-cena-fasada-4': '',
  'ocieplenie-budynku-z-otworami-cena-po-ulgach': '',
  'ocieplenie-budynku-wartosc-netto': '',
  'ocieplenie-budynku-vat-wartosc-percent': '',
  'ocieplenie-budynku-vat-kwota': '',
  'ocieplenie-budynku-wartosc-brutto': '',
  'ocieplenie-budynku-swiadectwa-efektywnosci-energetycznej': '',
  'ocieplenie-budynku-dotacja-czyste-powietrze': '',
  'ocieplenie-budynku-ulga-termomodernizacyjna': '',
  'ocieplenie-budynku-efektywny-poziom-dotacji': '',
  'ocieplenie-budynku-cena-po-dotacjach-i-ulgach': '',

  // ocieplenie-stropu-poddasza strona siedemnaście
  'ocieplenie-stropu-powierzchnia-warstwa-1': '',
  'ocieplenie-stropu-grubosc-warstwa-1': '',
  'ocieplenie-stropu-lambda-warstwa-1': '',
  'ocieplenie-stropu-material-warstwa-1': '',
  'ocieplenie-stropu-cena-warstwa-1': '',
  'ocieplenie-stropu-powierzchnia-warstwa-2': '',
  'ocieplenie-stropu-grubosc-warstwa-2': '',
  'ocieplenie-stropu-lambda-warstwa-2': '',
  'ocieplenie-stropu-material-warstwa-2': '',
  'ocieplenie-stropu-cena-warstwa-2': '',
  'ocieplenie-poddasza-powierzchnia-warstwa-1': '',
  'ocieplenie-poddasza-grubosc-warstwa-1': '',
  'ocieplenie-poddasza-lambda-warstwa-1': '',
  'ocieplenie-poddasza-material-warstwa-1': '',
  'ocieplenie-poddasza-cena-warstwa-1': '',
  'ocieplenie-poddasza-powierzchnia-warstwa-2': '',
  'ocieplenie-poddasza-grubosc-warstwa-2': '',
  'ocieplenie-poddasza-lambda-warstwa-2': '',
  'ocieplenie-poddasza-material-warstwa-2': '',
  'ocieplenie-poddasza-cena-warstwa-2': '',
  'ocieplenie-stropu-poddasza-wartosc-netto': '',
  'ocieplenie-stropu-poddasza-vat-wartosc-percent': '',
  'ocieplenie-stropu-poddasza-vat-wartosc-kwotowa': '',
  'ocieplenie-stropu-poddasza-wartosc-brutto': '',
  'ocieplenie-stropu-poddasza-swiadectwa-efektywnosci-energetycznej': '',
  'ocieplenie-stropu-poddasza-dotacja-czyste-powietrze': '',
  'ocieplenie-stropu-poddasza-ulga-termomodernizacyjna': '',
  'ocieplenie-stropu-poddasza-efektywny-poziom-dotacji': '',
  'ocieplenie-stropu-poddasza-cena-po-dotacjach-i-ulgach': '',

  // okna strona osiemnaście
  'okna-okno-1': '',
  'okna-okno-2': '',
  'okna-okno-3': '',
  'okna-okno-4': '',
  'okna-okno-5': '',
  'okna-okno-6': '',
  'okna-okno-7': '',
  'okna-okno-8': '',
  'okna-okno-9': '',
  'okna-okno-10': '',
  'okna-okno-11': '',
  'okna-okno-12': '',
  'okna-okno-13': '',
  'okna-okno-14': '',
  'okna-okno-15': '',
  'okna-okno-16': '',
  'okna-okno-17': '',
  'okna-okno-18': '',
  'okna-okno-19': '',
  'okna-okno-20': '',
  'okna-okno-21': '',
  'okna-okno-22': '',
  'okna-okno-23': '',
  'okna-okno-24': '',
  'okna-okno-25': '',
  'okna-parapety-zewnetrzne': '',
  'okna-parapety-wewnetrzne': '',
  'okna-wartosc-netto': '',
  'okna-vat-wartosc-percent': '',
  'okna-vat-kwota': '',
  'okna-wartosc-brutto': '',
  'okna-swiadectwa-efektywnosci-energetycznej': '',
  'okna-dotacja-czyste-powietrze': '',
  'okna-ulga-termomodernizacyjna': '',
  'okna-efektywny-poziom-dotacji': '',
  'okna-cena-po-dotacjach-i-ulgach': '',

  // drzwi-zewnetrzne strona dziewiętnaście
  'drzwi-zewnetrzne-model-drzwi-wejsciowe-drzwi-1': '',
  'drzwi-zewnetrzne-model-drzwi-wejsciowe-drzwi-2': '',
  'drzwi-zewnetrzne-model-drzwi-wejsciowe-drzwi-3': '',
  'drzwi-zewnetrzne-szt-drzwi-1': '',
  'drzwi-zewnetrzne-kolor-drzwi-1': '',
  'drzwi-zewnetrzne-typ-drzwi-1': '',
  'drzwi-zewnetrzne-przeszklenie-drzwi-1': '',
  'drzwi-zewnetrzne-okucie-drzwi-1': '',
  'drzwi-zewnetrzne-pochwyt-drzwi-1': '',
  'drzwi-zewnetrzne-aplikacje-ozdobne-drzwi-1': '',
  'drzwi-zewnetrzne-dodatki-drzwi-1': '',
  'drzwi-zewnetrzne-szt-drzwi-2': '',
  'drzwi-zewnetrzne-kolor-drzwi-2': '',
  'drzwi-zewnetrzne-typ-drzwi-2': '',
  'drzwi-zewnetrzne-przeszklenie-drzwi-2': '',
  'drzwi-zewnetrzne-okucie-drzwi-2': '',
  'drzwi-zewnetrzne-pochwyt-drzwi-2': '',
  'drzwi-zewnetrzne-aplikacje-ozdobne-drzwi-2': '',
  'drzwi-zewnetrzne-dodatki-drzwi-2': '',
  'drzwi-zewnetrzne-szt-drzwi-3': '',
  'drzwi-zewnetrzne-typ-drzwi-3': '',
  'drzwi-zewnetrzne-przeszklenie-drzwi-3': '',
  'drzwi-zewnetrzne-okucie-drzwi-3': '',
  'drzwi-zewnetrzne-pochwyt-drzwi-3': '',
  'drzwi-zewnetrzne-aplikacje-ozdobne-drzwi-3': '',
  'drzwi-zewnetrzne-dodatki-drzwi-3': '',
  'drzwi-zewnetrzne-nr-oferty-drzwi-4': '',
  'drzwi-zewnetrzne-nr-oferty-drzwi-5': '',
  'drzwi-zewnetrzne-nr-oferty-drzwi-6': '',
  'drzwi-zewnetrzne-wartosc-netto': '',
  'drzwi-zewnetrzne-vat-stawka-percent': '',
  'drzwi-zewnetrzne-vat-kwota': '',
  'drzwi-zewnetrzne-wartosc-brutto': '',
  'drzwi-zewnetrzne-swiadectwa-efektywnosci-energetycznej': '',
  'drzwi-zewnetrzne-dotacja-czyste-powietrze': '',
  'drzwi-zewnetrzne-ulga-termomodernizacyjna': '',
  'drzwi-zewnetrzne-efektywny-poziom-dotacji': '',
  'drzwi-zewnetrzne-cena-po-dotacjach-i-ulgach': '',
  'drzwi-zewnetrzne-kolor-drzwi-3': '',

  // okna-dachowe
  'okna-dachowe-producent-i-model-okno-1-producent': '',
  'okna-dachowe-producent-i-model-okno-1-model': '',
  'okna-dachowe-producent-i-model-okno-1-sztuk': '',
  'okna-dachowe-producent-i-model-okno-2-producent': '',
  'okna-dachowe-producent-i-model-okno-2-model': '',
  'okna-dachowe-producent-i-model-okno-2-sztuk': '',
  'okna-dachowe-producent-i-model-okno-3-producent': '',
  'okna-dachowe-producent-i-model-okno-3-model': '',
  'okna-dachowe-producent-i-model-okno-3-sztuk': '',
  'okna-dachowe-producent-i-model-okno-4-producent': '',
  'okna-dachowe-producent-i-model-okno-4-model': '',
  'okna-dachowe-producent-i-model-okno-4-sztuk': '',
  'okna-dachowe-wartosc-netto': '',
  'okna-dachowe-vat-stawka-percent': '',
  'okna-dachowe-vat-kwota': '',
  'okna-dachowe-wartosc-brutto': '',
  'okna-dachowe-swiadectwa-efektywnosci-energetycznej': '',
  'okna-dachowe-dotacja-czyste-powietrze': '',
  'okna-dachowe-ulga-termomodernizacyjna': '',
  'okna-dachowe-efektywny-poziom-dotacji': '',
  'okna-dachowe-cena-po-dotacjach-i-ulgach': '',
  'okna-dachowe-dane-techniczne-okno-1-wymiary': '',
  'okna-dachowe-dane-techniczne-okno-1-opis': '',
  'okna-dachowe-dane-techniczne-okno-2-wymiary': '',
  'okna-dachowe-dane-techniczne-okno-2-opis': '',
  'okna-dachowe-dane-techniczne-okno-3-wymiary': '',
  'okna-dachowe-dane-techniczne-okno-3-opis': '',
  'okna-dachowe-dane-techniczne-okno-4-wymiary': '',
  'okna-dachowe-dane-techniczne-okno-4-opis': '',

  // strona dwadzieścia jeden
  'santander-rata-miesieczna-brutto': '',
  'santander-liczba-rat': '',
  'bnp-paribas-rata-miesieczna-brutto': '',
  'bnp-paribas-liczba-rat': '',
  'inbank-rata-miesieczna-brutto': '',
  'inbank-liczba-rat': '',
  'tf-bank-rata-miesieczna-brutto': '',
  'tf-bank-liczba-rat': '',
};

const daysToExpireIdentifier = 'days-to-expire';

const PAGE_FIELD_MAPPING: { [key: number]: string[] } = {
  3: ['fotowoltaika-moc-instalacji', 'fotowoltaika-naslonecznienie', 'fotowoltaika-moduly-nazwa-modulu'],
  4: ['fotowoltaika-hybrydowa-parametry-instalacji-moc-instalacji', 'fotowoltaika-hybrydowa-moduly-nazwa-modulu'],
  5: ['pompa-ciepła-co-cwu-parametry-instalacji-moc-dobranej-instalacji', 'pompa-ciepla-co-cwu-producent-i-model'],
  6: ['klim-1-model', 'klim-2-model', 'klim-wartosc-netto'],
  7: ['kociol-peletowy-parametry-instalacji-moc-dobranej-instalacji', 'kociol-na-pellet-model'],
  8: ['kociol-zgazowujacy-drewno-parametry-moc-dobranej-instalacji', 'kociol-na-zgazowanie-producent-i-model'],
  9: ['kociol-gazowy-1-moc-dobranej-instalacji', 'kociol-gazowy-1-producent-model'],
  10: ['kociol-gazowy-2-moc-dobranej-instalacji', 'kociol-gazowy-2-producent-model'],
  11: ['kociol-elektryczny-moc-dobranej-instalacji', 'kociol-elektryczny-producent-model'],
  12: ['elektryczne-folie-maty-promienniki-m2-folii-grzewczych', 'elektryczne-folie-maty-promienniki-folie-grzewcze'],
  13: ['pompa-ciepla-cwu-moc-instalacji', 'pompa-ciepla-cwu-producent-model'],
  14: ['kolektory-sloneczne-ilosc-kolektorow', 'kolektory-sloneczne-producent-i-model'],
  15: ['modernizacja-centralnego-ogrzewania-ilosc-grzejnikow', 'modernizacja-centralnego-ogrzewania-powierzchnia-ogrzewania'],
  16: ['ocieplenie-budynku-powierzchnia-fasada-1', 'ocieplenie-budynku-wartosc-netto'],
  17: ['ocieplenie-stropu-powierzchnia-warstwa-1', 'ocieplenie-stropu-poddasza-wartosc-netto'],
  18: ['ocieplenie-stropu-powierzchnia-warstwa-1', 'ocieplenie-stropu-piwnicy-wartosc-netto'],
  19: ['okna-okno-1', 'okna-wartosc-netto'],
  20: ['drzwi-zewnetrzne-model-drzwi-wejsciowe-drzwi-1', 'drzwi-zewnetrzne-wartosc-netto'],
  21_22: ['bramy-garazowe-model-bramy', 'bramy-garazowe-model-bramy-2', 'bramy-garazowe-wartosc-netto'],
  23: ['okna-dachowe-producent-i-model-okno-1-producent', 'okna-dachowe-wartosc-netto'],
  24: ['rekuperacja-ilosc-anemostatów', 'rekuperacja-producent-i-model', 'rekuperacja-wartosc-netto'],
  25: ['santander-rata-miesieczna-brutto', 'bnp-paribas-rata-miesieczna-brutto', 'inbank-rata-miesieczna-brutto', 'tf-bank-rata-miesieczna-brutto'],
};

export function useCalculationPdfData() {
  const userStore = useUserStore();

  const { currentClient } = useCurrentClient();

  const { pdfsRules } = useCurrentEstimatedPdfs();

  function fillRulesToPdfJson() {
    const pdfJson = { ...PDF_JSON };

    if (!currentClient.value) {
      throw new Error('Client is not selected');
    }

    const { first_name, last_name, postal_code, city, street, apartment_number, house_number } =
      currentClient.value;

    const formattedApartmentNumber = apartment_number ? `/${apartment_number}` : '';

    pdfJson.dla = `${first_name} ${last_name}`;
    pdfJson.adres = `${street} ${house_number}${formattedApartmentNumber} ,${postal_code} ${city}`;

    pdfJson.energy_advisor_name = `${userStore.user?.first_name} ${userStore.user?.last_name}`;
    pdfJson.energy_advisor_phone_number = userStore.user?.phone || '-';
    pdfJson.energy_advisor_email = userStore.user?.email || '-';
    pdfJson.energy_advisor_branch_location = userStore.user?.branch || '-';

    pdfsRules.value?.forEach((rule) => {
      if (rule.pdf_field_identifier === daysToExpireIdentifier) {
        pdfJson[rule.pdf_field_identifier] = addDaysToDate(Number(rule.eval));
        return;
      }

      if (!rule.pdf_field_identifier) return;

      pdfJson[rule.pdf_field_identifier] = rule.eval;
    });
    return pdfJson;
  }

  function detectVisiblePages() {
    const pdfJson = fillRulesToPdfJson();
    const visiblePages: { [key: string]: boolean } = {
      showPage1: true,
      showPage2: true,
    };

    Object.entries(PAGE_FIELD_MAPPING).forEach(([pageNumber, fieldIdentifiers]) => {
      visiblePages[`showPage${pageNumber}`] = fieldIdentifiers.some((fieldId) => {
        const value = pdfJson[fieldId];
        return value !== undefined && value !== null && value !== '';
      });
    });

    return visiblePages;
  }

  function getCompletePdfData() {
    const pdfJson = fillRulesToPdfJson();
    const visiblePages = detectVisiblePages();

    return {
      ...pdfJson,
      ...visiblePages,
    };
  }

  function getAgreementData() {
    return detectVisiblePages();
  }

  return { fillRulesToPdfJson, detectVisiblePages, getCompletePdfData, getAgreementData };
}
